import { makeContext } from '../../utils'
import { initialProvider } from './initial'

export const { Provider: InbrainProvider, useContext: useInbrain } = makeContext(initialProvider === 'inbrain', 'InbrainProviderContext')
